import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
//import counterReducer from '../features/counter/counterSlice';
import userReducer from '../redux/user';
import applicationReducer from '../redux/application';
import signReducer from '../redux/sign';
import pollReducer from '../redux/polls';
import persistState from '../utils/persistState';


const persistStateEnhancer = persistState(['user']);


export const store = configureStore({
  reducer: {
    user: userReducer,
    application: applicationReducer,
    sign: signReducer,
    poll: pollReducer
  },
  enhancers: [persistStateEnhancer],
  middleware: getDefaultMiddleware({
    immutableCheck: {
      //Список узлов стейта где не будет проверятся мутирование
      ignoredPaths: [
        //В этот узел заносится файл ключа при подписи, это не сериализируемый объект и почему то immer
        //ругается на мутирование стейта, но стейт не мутируется, поэтому просто заклеим красную лампочку черной изолентой
        'sign.privateKeyFile'
      ]
    },
    serializableCheck: {
      //Список экшенов которые будут пихать в стор не сериализируемые объекты
      ignoredActions: [
        'sign/setPrivateKeyFile'
      ],
      ignoredPaths: [
        'sign.privateKeyFile' //Ключ шифрования
      ]
    }
  })
});
